import styled from 'styled-components';
import {SWIPER_MODE} from '../../../css-constants';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    display: flex;
    align-items: center;
    width: 32%;
    margin: 10px 1% 0 0.25rem;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 5rem;
    cursor: pointer;
    user-select: none;
`;

const PcBox = styled(DefaultBox)`
     justify-content: center;
     &.${SWIPER_MODE} {
        flex-shrink: 0;
    }
`;

const MobileBox = styled(DefaultBox)`
    flex-direction: row;
    justify-content: space-around;

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: 49%;
        flex-shrink: 0;
        padding: 0.5rem;
        margin-right:0;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: 100%;
        padding: 0 2em 1em;
        margin-left:0;
        margin-right:0;
        margin-bottom: 1rem;
    }
`;



export const GameDefaultBox = styledByDevice(PcBox, MobileBox);

